import YoutubePlayer from './YoutubePlayer';
import YoutubePlayerWithRemocon from './YoutubePlayerWithRemocon';
import YoutubePlayerWithRemoconDemo from './YoutubePlayerWithRemoconDemo';

export {
  YoutubePlayer,
  YoutubePlayerWithRemocon,
  YoutubePlayerWithRemoconDemo
};

export default YoutubePlayer; 